import React from "react"
import Select from "react-select"
import PropTypes from "prop-types"

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    height: "51px",
    borderRadius: "10px",
    paddingLeft: '2px',
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    fontSize: "12px",
    boxShadow: state.isFocused ? '0px 0px 2px 2px rgba(34, 60, 80, 0.2)': 'none',
    border: state.isFocused ? '2px solid rgba(63, 65, 88, 0.7)': 'none',
   }),
  singleValue: (provided) => ({
    ...provided,
    color: 'rgba(63, 65, 88, 0.7)',

  }),
  option: (provided, state) => {
    let bgColor = 'white'
    if (state.isFocused){
      bgColor = 'rgba(207, 206, 206, 0.2)'
    }
    if (state.isSelected){
      bgColor = 'rgba(207, 206, 206, 0.5)'
    }
    return({
      ...provided,
      color: state.isSelected ? "black" : "rgba(63, 65, 88, 0.7)",
      backgroundColor: bgColor,
      fontFamily: "Lato, sans-serif",
      fontWeight: "bold",
      fontSize: "12px"
    })
  }
}
const defaultValue = (options, value) => {
  return options ? options.find(option => option.value === value) : ""
}
export const SelectInput = ({
                              onChange,
                              options,
                              value
                            }) => (
  <Select
    options={options}
    value={defaultValue(options, value)}
    onChange={value => onChange(value)}
    styles={customStyles}
  />
)

SelectInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }).isRequired
}
